import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

type Emits = {
  (e: 'onClicked', event: Event): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TableRow',
  emits: ["onClicked"],
  setup(__props, { emit: __emit }) {

const emits = __emit
function handleClick(event: Event) {
  emits('onClicked', event)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", { onClick: handleClick }, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})